export const AUTH_START_SIGNING_IN = "AUTH_START_SIGNING_IN";
export const AUTH_END_SIGNING_IN = "AUTH_END_SIGNING_IN";
export const AUTH_SET_EMAIL = "AUTH_SET_EMAIL";
export const AUTH_CLEAR_ERROR = "AUTH_CLEAR_ERROR";
export const AUTH_SET_ERROR = "AUTH_SET_ERROR";
export const AUTH_CLEAR_AUTH_DATA = "AUTH_CLEAR_AUTH_DATA";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";

export const SETTINGS_TOGGLE_EXPAND = "SETTINGS_TOGGLE_EXPAND";
